import BaseAction from "../base-action";
import SceneStateController from "@/features/sceneStateManager/sceneStateController";

class BaseSelectionFeature extends BaseAction {
    currentlySelecting;
    selectionObjectType;
    hideMenuItems;

    constructor(props = {}) {
        super(props);
        let self = this;

        this.currentlySelecting = false;
        this.selectionObjectType = null;
        this.hideMenuItems = false;
        this.currentItems = [];
        this.selectionEnable = false;

        wv.communicator.addEventListener(text_startSelection, function (params) {
            self.startSelectionCallback(params);
        });
        wv.communicator.addEventListener(text_stopSelection, function (itemArr) {
            self.stopSelectionCallback(itemArr);
        });
        wv.communicator.addEventListener(text_selectionObjects, function (params) {
            self.objectSelectionCallback(params);
        });

    }

    startSelectionCallback(params) {
        SceneStateController.saveServerlessLocalState();

        const actionId = params.actionId;
        this.selectionObjectType = params.selectionObjectType;
        this.selectionEnable = params.selectionEnable;
        if (!this.shouldExecute(actionId)) return;
        const vrMessage = params.vrMessage || "Start Selecting " + this.selectionObjectType;
        this.currentlySelecting = true;
        VRMessageController.addMessage({
            text: vrMessage,
            priority: VrMessagePriorityEnum.LOWPRIORITYINFO
        });
        this.currentItems = params.items ? params.items : [];
        this.set2dElementsVisibility(false);
        clearAllFeaturesFromAllHandler();
        ModelTreeControllerFor2D.deselectAllNodes();
        SelectionData.resetAllSelection();

        this.updateReverseSelection(params.reverseSelection);
        onChangeSelectionTooltip(params.enableTooltip);
        this.startSelection();
    }

    async stopSelectionCallback(itemArr) {
        const actionId = itemArr[0];
        this.currentItems = [];
        if (!this.shouldExecute(actionId)) return;
        if (this.currentlySelecting === false) return;
        this.currentlySelecting = false;
        this.selectionObjectType = null;
        this.stopSelection();
    }

    objectSelectionCallback(params) {
        if (this.actionType !== params.selectionActionType || !this.currentlySelecting || this.selectionObjectType !== params.selectionObjectType) return;
        ModelTreeControllerFor2D.getMultiSelector().clearAll();
        this.selectItems(params.items, params.enable);
    }

    isActiveOperation(operationName) {
        if (operationName.includes(this.selectionObjectType) && this.selectionObjectType !== null
            && operationName.includes(this.selectionObjectType)) {
            return true;
        }
        return false;
    }

    getCurrentItems() {
        return this.currentItems;
    }

    setCurrentItems(items) {
        this.currentItems = items;
    }

    updateReverseSelection(value) {
        if (value !== undefined) {
            SelectionData.changeReverseSelectionState(value);
            if (this.actionType === ActionTypeEnum.VISIBILITY) {
                SelectionData.changeReverseHighlightState(value);
            }
        }
    }

    set2dElementsVisibility(value) {
        this.hideMenuItems = !value;
        let _2dElements = getAll2DElements();
        _2dElements.forEach(element => {
            element.style.visibility = value ? 'visible' : 'hidden';
        });

        if (!value) {
            mController.hideWholeMenu();
        }

        JSTreeManager.hideAllOtherTreeViews();
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', false);
        this.hideTreesExcept();
    }

    hideTreesExcept(treeItem = "") {
        let hiddenTreeItems = ["treeViewData", "groupTreeView", "infoTagTreeView", "animationTreeView"];
        hiddenTreeItems.forEach(item => {
            if (treeItem === "" || item === treeItem) document.getElementById(item).style.display = 'block';
            else document.getElementById(item).style.display = 'none';
        })
    }

    show2dItemsForBranchSelection() {
        const modelTreeViewList = document.getElementsByClassName('modelTreeView');
        const selectorButtons = document.getElementsByClassName('modelTreeSelectorClass');
        const itemsToShow = [...modelTreeViewList, ...selectorButtons];
        for (let item of itemsToShow) {
            item.style.visibility = 'visible';
        }

        this.change2dVisibility(false);

        JSTreeManager.showFeatureListTreeView('AvailableFileListViewSideNav', false);
        this.hideTreesExcept("treeViewData");
    }

    change2dVisibility(visible) {
        ModelTreeControllerFor2D.showModelTree = !visible;
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', ModelTreeControllerFor2D.showModelTree);
        let items = document.getElementById('modelTreeSelectorChildData');
        for (let childItem of items.childNodes) {
            if (!childItem.style) {
                continue;
            }

            if (visible || childItem.id === 'FindInTree2D') {
                childItem.style.display = 'block';
            } else {
                childItem.style.display = 'none';
            }
        }
    }

    show2dItemsForGroupSelection() {
        const modelTreeViewList = document.getElementsByClassName('modelTreeView');
        const selectorButtons = document.getElementsByClassName('modelTreeSelectorClass');
        const itemsToShow = [...modelTreeViewList, ...selectorButtons];
        for (let item of itemsToShow) {
            item.style.visibility = 'visible';
        }

        JSTreeManager.hideAllOtherTreeViews();
        ModelTreeControllerFor2D.showModelTree = true;
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', ModelTreeControllerFor2D.showModelTree);
        let items = document.getElementById('modelTreeSelectorChildData');
        items.style.display = 'none';
        JSTreeManager.showFeatureListTreeView('AvailableFileListViewSideNav', false);
        this.hideTreesExcept("groupTreeView");
    }

    cancel() {
        if (this.currentlySelecting) {
            this.currentlySelecting = false;
            this.selectionObjectType = null;
            this.stopSelection();
        }
    }

    sendDataToWeb(messageCommand, data, undoReverse) {
        if (!this.currentlySelecting) {
            return;
        }

        // Add extra property for UserAction: Move Objects
        if (ActionController.getActiveAction()?.actionType === ActionTypeEnum.USER_ACTION_MOVE_OBJECTS) {
            data.expectedValue = ModelTreeControllerFor2D.clickedElementsBranchIDs[data.item.id]?.value;
            data.testCase = ModelTreeControllerFor2D.clickedElementsBranchIDs[data.item.id]?.case;
        }

        let payload = {
            message: messageCommand,
            selectionData: data,
            undoReverse: undoReverse,
            selectionActionType: this.actionType,
            selectionObjectType: this.selectionObjectType,
            actionId: ActionController.getActiveAction()?.actionId,
        };
        wv.communicator.socket.communicateWithContainer(payload);
    }
}

export default BaseSelectionFeature;
